var FIRST_COUNT = false;
var checkInterval;
var isMouseOverActive = false;
var moveTimer;
var index = 0;

// handle hidden mouseover on active slide
if ($(window).width() < 768) {
  $(document)
    .on('mouseenter', '.gallery .swiper-slide-active', function() {
      isMouseOverActive = true;
    })
    .on('mouseleave', '.gallery .swiper-slide-active', function() {
      isMouseOverActive = false;
    });
  $(document).on('mousemove', '.swiper-slide-active', function () {
    clearTimeout(moveTimer);
    isMouseOverActive = true;
    moveTimer = setTimeout(function(){
      isMouseOverActive = false;
      index = 4000;
    }, 4000);

  });
}

// handle video pause check
function checkVideoPause() {
  checkInterval = setInterval(function() {
    var widthSeekbar = $('.gallery .swiper-slide-active').find('.lac-seekbar-wrap').width();
    var lacSeekBar = $('.gallery .swiper-slide-active').find('.lac-seekbar-current').width();
    if ($(window).width() < 768) {
      $('body').find('.liveact-controls--faded-out').removeClass('liveact-controls--faded-out');
      index += 200;
      if (isMouseOverActive) {
        index = 0;
      }
      if (index >= 4000)  {
        $('.gallery .swiper-slide-active').find('.liveact-controls').addClass('faded-out');
      } else {
        $('.gallery .swiper-slide-active').find('.liveact-controls').removeClass('faded-out');
      }
    }
    if (widthSeekbar === lacSeekBar) {
      $('.gallery .swiper-slide-active').find('.lac-screen-play').removeClass('liveact-player__element--invisible');
      clearInterval(checkInterval);
      $('.gallery .swiper-slide-active').find('.liveact-controls').removeClass('faded-out');
    }
  }, 200);
}

jQuery(function ($) { // この中であればWordpressでも「$」が使用可能になる

  var topBtn = $('.to-top_3');
  topBtn.hide();

  // ボタンの表示設定
  $(window).scroll(function () {
    if ($(this).scrollTop() > 70) {
      // 指定px以上のスクロールでボタンを表示
      topBtn.fadeIn();
    } else {
      // 画面が指定pxより上ならボタンを非表示
      topBtn.fadeOut();
    }
  });

  // ボタンをクリックしたらスクロールして上に戻る
  topBtn.on('click', function (e) {
    e.preventDefault();
    window.scrollTo(0, 0);
  })

  //ドロワーメニュー
  $("#MenuButton").click(function () {
    // $(".l-drawer-menu").toggleClass("is-show");
    // $(".p-drawer-menu").toggleClass("is-show");
    $(".js-drawer-open").toggleClass("open");
    $(".drawer-menu").toggleClass("open");
    $("html").toggleClass("is-fixed");

  });

  $('.product-list__column01').on('click', function (e) {
    e.preventDefault();
    $('.card').addClass('is-active');
    $('.product-list__column01').removeClass('is-active');
    $('.product-list__column02').addClass('is-active');
    setCookie('numbercolumn', 3);
    return false;
  });

  $('.product-list__column02').on('click', function (e) {
    e.preventDefault();
    $('.card').removeClass('is-active');
    $('.product-list__column01').addClass('is-active');
    $('.product-list__column02').removeClass('is-active');
    setCookie('numbercolumn', 2);
    return false;
  });

  jQuery(window).on("scroll", function() {
    // トップから100px以上スクロールしたら
    if (100 < jQuery(this).scrollTop()) {
      // is-showクラスをつける
   jQuery('.to-top').addClass( 'is-show' );
    } else {
      // 100pxを下回ったらis-showクラスを削除
    jQuery('.to-top').removeClass( 'is-show' );
    }
  });

  jQuery(function($){
    $(function(){
      $('.drawer-pc-price').on('click', function() {
        if ($(this).prop('checked')){
          // 一旦全てをクリアして再チェックする
          $('.drawer-pc-price').prop('checked', false);
          $(this).prop('checked', true);
        }
      });
    });
  });

  jQuery(function($){
    $(function(){
      $('.drawer-pc-stock').on('click', function() {
        if ($(this).prop('checked')){
          // 一旦全てをクリアして再チェックする
          $('.drawer-pc-stock').prop('checked', false);
          $(this).prop('checked', true);
        }
      });
    });
  });

  $(document).on('click', '.product-list__select-wrapper--narrow', function () {
    $('body').addClass('lock_scroll');
    $('.drawer-pc').fadeIn();
    $('.drawer-pc-background').fadeIn();
  });

  $('.header__hamburger-sp').on('click', function () {
    $('.drawer-pc').fadeIn();
  });

  $(document).on('click', '.drawer-pc__icon', function () {
    $('body').removeClass('lock_scroll');
    $('.drawer-pc').fadeOut();
    $('.drawer-pc-background').fadeOut();
  });

  $(document).on('click', '.drawer-pc-background', function () {
    $('body').removeClass('lock_scroll');
    $('.drawer-pc').fadeOut();
    $('.drawer-pc-background').fadeOut();
  });

  $(function(){
    var $maincontent = $('#maincontent');
    var $tracking_pv = $('#tracking_pv_staffstart');
    if ($tracking_pv && $tracking_pv.data('content-id')) {
      var content_id = $tracking_pv.data('content-id');
      var user_id = $maincontent.data('user-id');
      var session_id = $maincontent.data('session-id');
      var merchant_id = $maincontent.data('merchant-id');
      const ss_pv_info = {
        content_type: "1",
        content_id: content_id,
        user_id: user_id,
        session_id: session_id,
      }
      staffStart.pv.sendTrackingRequest(merchant_id, ss_pv_info);
    }
    //クリックで動く
    $(document).on('click', '.sidenav_button_1:not(".disabled")',function(){
      $('.drawer-pc__dl').toggleClass('active');
      $('.drawer-pc__icon_2').toggleClass('active');
      $('.sidenav_1').toggle();
    });

    $(document).on('click', '.sidenav_button_1_push, .sidenav_1 .drawer-pc__icon_2', function(){
      $('.drawer-pc__dl').toggleClass('active');
      $('.drawer-pc__icon_2').toggleClass('active');
      $('.sidenav_1').toggle();
    });

    $(document).on('click', '.sidenav_button_2:not(".disabled")',function(){
      $('.drawer-pc__dl').toggleClass('active');
      $('.drawer-pc__icon_2').toggleClass('active');
      $('.sidenav_2').toggle();
    });

    $(document).on('click','.sidenav_button_2_push, .sidenav_2 .drawer-pc__icon_2',function(){
      $('.drawer-pc__dl').toggleClass('active');
      $('.drawer-pc__icon_2').toggleClass('active');
      $('.sidenav_2').toggle();
    });

    $(document).on('click', '.sidenav_button_3:not(".disabled")',function(){
      $('.drawer-pc__dl').toggleClass('active');
      $('.drawer-pc__icon_2').toggleClass('active');
      $('.sidenav_3').toggle();
    });

    $(document).on('click','.sidenav_button_3_push, .sidenav_3 .drawer-pc__icon_2',function(){
      $('.drawer-pc__dl').toggleClass('active');
      $('.drawer-pc__icon_2').toggleClass('active');
      $('.sidenav_3').toggle();
    });

    $(document).on('click', '.sidenav_button_4:not(".disabled")',function(){
      $('.drawer-pc__dl').toggleClass('active');
      $('.drawer-pc__icon_2').toggleClass('active');
      $('.sidenav_4').toggle();
    });

    $(document).on('click','.sidenav_button_4_push, .sidenav_4 .drawer-pc__icon_2',function(){
      $('.drawer-pc__dl').toggleClass('active');
      $('.drawer-pc__icon_2').toggleClass('active');
      $('.sidenav_4').toggle();
    });

    $(document).on('click','.click_title',function(){
      $(this).toggleClass('active');
      $(this).next('.accordion_innner').slideToggle();
    });

    $(document).on("click",".clearForm_1", function(){
      $('.sidenav_1 .input_clear').prop('checked', false);
    });
    $(document).on("click", ".clearForm_2", function(){
      $('.sidenav_2 .input_clear').prop('checked', false);
    });
    $(document).on("click", ".clearForm_3", function(){
      $('.sidenav_3 .input_clear').prop('checked', false);
      $('.sidenav_3 select').val('');
    });
    $(document).on("click", ".clearForm_4", function(){
      $('.sidenav_4 .input_clear').prop('checked', false);
      $('.sidenav_4 select').val('');
    });
  });


  if (matchMedia('(max-width: 767px)').matches) {
   var thumbs = new Swiper ('.js-thumbs-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 12,
      centeredSlides: false,
      slideToClickedSlide: true,
    });
  } else {
   var thumbs = new Swiper ('.js-thumbs-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 10,
      centeredSlides: true,
      slideToClickedSlide: true,
    });
  }
  

  var swiper = new Swiper(".js-gallery-swiper", {
    slidesPerView: 1,
    centeredSlides: false,
    loop: true,
    a11y: false,
    loopedSlides: 1, //スライドの枚数と同じ値を指定

    // 追加：タッチ操作を動画に伝える設定
    // Additional settings for videos
    // Settings for transmitting touch operations to videos
    touchStartPreventDefault: false,
    passiveListeners: false,

    pagination: {
      el: ".swiper-pagination",
      type: "custom",
      renderCustom: function (_, current, total) {
        return `<span class="swiper-pagination-current">${current}</span>/<span class="swiper-pagination-total">${total}</span>`;
      },
    },
    on: {
      sliderMove: function () {
        if ($(window).width() < 768) {
          $('body').css('overflow', 'hidden');
        }
      },
      touchEnd: function () {
        if ($(window).width() < 768) {
          $('body').css('overflow', '');
        }
      },
      slideChangeTransitionEnd: function () {
        if ($(window).width() < 768) {
          $('body').css('overflow', '');
        }
        var activeSlide = swiper.slides[swiper.activeIndex];
        var video = activeSlide.querySelector('video');
        if (checkInterval) {
          clearInterval(checkInterval);
        }
        if (video) {
          index = 0; // reset when slide is active
          checkVideoPause();
        }
      }
    },
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
    thumbs: {
      swiper: thumbs,
    },
  });

  // LiveActのシークバーだけSwiper無効にする処理
  // Disable Swiper only for LiveAct's seek bar
  const swiperInstance = document.querySelector('.js-gallery-swiper').swiper;

  document.querySelectorAll('.cri-liveact-player').forEach((player) => {
    const isSeekbarRelated = (e) =>
      e.target.closest('.lac-row') ||
      e.target.closest('.lac-seekbar') ||
      e.target.closest('.lac-seekbar-pointer');

    // 操作開始時：シークバー系を触っていたらSwiper停止
    // When starting operation: If you touch the seek bar, Swiper will stop
    ['touchstart', 'mousedown'].forEach((eventName) => {
      player.addEventListener(eventName, (e) => {
        if (isSeekbarRelated(e)) {
          swiperInstance.allowTouchMove = false;
        }
      }, { passive: false });
    });

    // 操作終了時：常にSwiperを再有効化
    // When finished: Always re-enable Swiper
    ['touchend', 'mouseup'].forEach((eventName) => {
      player.addEventListener(eventName, () => {
        swiperInstance.allowTouchMove = true;
      });
    });
  });


  /*
     var slider = new Swiper ('.js-recommend-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      slidesPerView: 2.2,
      //centeredSlides: true,
      loop: true,
      loopedSlides: 4, //スライドの枚数と同じ値を指定
      navigation: {
        nextEl: '.swiper-recommend-next',
      },
  
      breakpoints: {
        694: {
         spaceBetween: 10,
         centeredSlides: false,
         slidesPerView: 2.2,
        }
       },
  
    });
    */


  if (matchMedia('(max-width: 767px)').matches) {
    // ウィンドウサイズが694px以下のとき

      var slider = new Swiper ('.js-recommend-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      slidesPerView: 2.3,
      //centeredSlides: true,
      loop: true,
      loopedSlides: 4, //スライドの枚数と同じ値を指定
      navigation: {
        nextEl: '.swiper-recommend-next',
      },

    });


  } else {
    // それ以外

      var slider = new Swiper ('.js-recommend-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      slidesPerView: 4,
      //centeredSlides: true,
      loop: true,
      loopedSlides: 4, //スライドの枚数と同じ値を指定
      navigation: {
        nextEl: '.swiper-recommend-next',
      },

    });

  }





  if (matchMedia('(max-width: 694px)').matches) {
    // ウィンドウサイズが694px以下のとき

      var slider = new Swiper ('.js-item-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      slidesPerView: 2.3,
      //centeredSlides: true,
      loop: true,
      loopedSlides: 4, //スライドの枚数と同じ値を指定
      navigation: {
        nextEl: '.swiper-item-next',
      },

    });


  } else {
    // それ以外

      var slider = new Swiper ('.js-item-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      slidesPerView: 4,
      //centeredSlides: true,
      loop: true,
      loopedSlides: 4, //スライドの枚数と同じ値を指定
      navigation: {
        nextEl: '.swiper-item-next',
      },

    });



  }




  $(function(){
    $(document).on("click", ".sidenav_1 .sidenav_input, .sidenav_2 .sidenav_input", function(){
      $('.sidenav_1 .sidenav_input, .sidenav_2 .sidenav_input').prop('checked', false);
      $(this).prop('checked', true);
    });
  });
  // スムーススクロール (絶対パスのリンク先が現在のページであった場合でも作動)

  $(document).on('click', 'a[href*="#"]', function () {
    let time = 400;
    let header = $('header').innerHeight();
    let target = $(this.hash);
    if (!target.length) return;
    let targetY = target.offset().top - header;
    $('html,body').animate({ scrollTop: targetY }, time, 'swing');
    return false;
  });

});


// 絞り込みエリアがヘッダー下部にsticky状態でクラス付与
$(function () {
  const stickyObserver = new window.IntersectionObserver((entry) => {
    if (!entry[0].isIntersecting && $('.conditions').css('display') != 'none') {
      $('.sticky-pc').addClass('sticky-border');
    } else {
      $('.sticky-pc').removeClass('sticky-border');
    }
  });

  const stickyTop = $('.sticky-top');
  if (stickyTop[0] && $('.conditions')[0]) {
    stickyObserver.observe(stickyTop[0]);
  }
});


//[TL_FOR_RUBY-3215] Replace all params in staff_site url except for choosen params
var listOfParams = ['id', 'start',  'page'];
function removeParameterExcludeParamList(listOfParams) {
  const url = new URL(window.location.href);
  const baseUrl = url.origin + url.pathname;
  const newSearchParams = new URLSearchParams();
  for (var i = 0; i < listOfParams.length; i++) {
    if (url.searchParams.has(listOfParams[i])) {
      var paramVal = url.searchParams.get(listOfParams[i]);
      newSearchParams.set(listOfParams[i], paramVal);
    }
  }

  const newUrl = baseUrl + '?' + newSearchParams.toString();
  history.replaceState(null, '', newUrl);
}
removeParameterExcludeParamList(listOfParams);

var getCurrentParamsUrl = (url) => {
  return Object.entries(Object.fromEntries(new URLSearchParams(new URL(url).search))).reduce((a,[k,v]) => (v == '' && v ? a : (a[k]=v, a)), {});
};

var getCount = (url, paramsURL, params) => {
  if (FIRST_COUNT) {
    var inputbtn = $('form.drawer-pc__form button[type="submit"]');
    $.ajax({
      method: 'get',
      data: paramsURL ? getCurrentParamsUrl(paramsURL) : params,
      url: url,
      async: true,
      beforeSend: function () {
        inputbtn.html('<div class="loading"></div>');
        inputbtn.prop('disabled', true);
      },
      success: function (response) {
        if (parseInt(response.count, 10) === 0) {
          inputbtn.text(`絞り込む (${response.count.replace(/\B(?=(\d{3})+(?!\d))/g, ",")})`)
        } else {
          inputbtn.prop('disabled', false);
          inputbtn.text(`絞り込む (${response.count.replace(/\B(?=(\d{3})+(?!\d))/g, ",")})`);
        }
      },
      error: function () {
      }
    })
  }
}
var tag_search_result = (value, text, name, outside) => {
  var safestring = $('<div>').text(text).html();
  return `<div class="tag_icon" data-val="${value}" data-elm-name="${name}"><span>${safestring}</span><div class="tag_icon_close ${outside ? 'outside' : ''}"><a href="javascript:void(0)"></a></div></div>`;
}
//=============================== SORT TYPE =====================================//
$(function () {
  $('#sortFilter').on('change', function (e) {
    var select = this;
    e.preventDefault();
    switch ($(select).val()) {
      case 'time': case 'pv': case 'sales':
        break;
      default:
        return;
    }
    var anotherParams = getCurrentParamsUrl(location.href);
    var data = Object.assign(anotherParams, { sort : $(select).val() });
    var numbercolumn = getCookie('numbercolumn');
    var actionUrl = appendQueryString($(select).data('action-url'), 'numbercolumn', numbercolumn);
    $.ajax({
      url: actionUrl,
      type: 'get',
      dataType: 'json',
      data: data,
      async: false,
      success: function (response) {
        $('.product-list__inner.inner > .product-list__header').nextAll().remove()
        $('.product-list__inner.inner > .product-list__header').after(response.renderTemplate);
        // Get the current URL parameters
        var currentParams = new URLSearchParams(window.location.search);
        currentParams.set('sort', $(select).val());
        var newURL = window.location.pathname + '?' + currentParams.toString();
        // Update the URL without reloading the page
        window.history.pushState({}, '', newURL);
        var form = $('#maincontent form.drawer-pc__form');
        var action = form.prop('action');
        form.prop('action', URLhelper('all', form.data('base-url'), action, { sort: $(select).val() }));
      },
      error: function (data) {
        //reset prev error
      }
    })
  })
})

function appendQueryString(url, key, value) {
  let newUrl = new URL(window.location.origin + url);
  newUrl.searchParams.append(key, value);
  return newUrl.toString();
}

function setCookie(cname, cvalue) {
  const d = new Date();
  d.setTime(d.getTime() + (30*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cookieName) {
  var name = cookieName + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookieArray = decodedCookie.split(';');
  for (var i = 0; i < cookieArray.length; i++) {
    var cookieItem = cookieArray[i];
    while (cookieItem.charAt(0) === ' ') {
      cookieItem = cookieItem.substring(1);
    }
    if (cookieItem.indexOf(name) === 0) {
      return cookieItem.substring(name.length, cookieItem.length);
    }
  }
  return '';
}


var setParamsSort = (type, selector) => {
  var result = [];
  switch (type) {
    case 'select':
      result.push($(selector).data('val'))
      break;
    case 'checkbox':
      $(`input[name="${selector}"]:checked`).each(function (i, elm) {
        result.push($(elm).val())
      })
      break;
    default:
      break;
  }
  return result.join(',');
}

var URLhelper = (mode, baseURL, oldURL, newParams) => {
  if (mode === 'all') {
    var params = getCurrentParamsUrl(oldURL);
    return baseURL + '?' + $.param(Object.assign(params, newParams));
  } else if( mode === 'only'){
    return baseURL + '?' + $.param(newParams);
  } else if ( mode === 'exclude') {
    var params = getCurrentParamsUrl(oldURL);
    newParams.split(',').forEach(function (exparam, i) {
      delete params[exparam];
    })
    return baseURL + '?' + $.param(params);
  }
}

var addTag = (element, listTagName, inputName) => {
  $(document).on('click', element , function () {
    $(listTagName).empty();
    $(`input[name="${inputName}"]:checked`).each(function (i, elm) {
      $(listTagName).append(tag_search_result($(elm).val(), $(elm).parent().text(), inputName));
      if (!FIRST_COUNT) {
        if ($(elm).val()) $('.product-list__header .conditions__items').append(tag_search_result($(elm).val(), $(elm).parent().text(), inputName, true))
      }
    });

    if($(`input[name="${inputName}"]:checked`).length > 0) {
      if ($(listTagName).siblings("dt").children('p')) $(listTagName).siblings("dt").children('p').text('');
    }

    var form = $('#maincontent form.drawer-pc__form');
    var action = $('#maincontent form.drawer-pc__form').prop('action');
    form.prop('action',URLhelper('all', form.data('base-url'), action, {[inputName]: setParamsSort('checkbox', inputName)}));
    getCount(form.data('count-url'),form.prop('action'));
  })
}

var appendUrl = (page, url) => {
  if (typeof (history.pushState) !== 'undefined') {
    var obj = { Page: page, Url: url};
    history.pushState(obj.Page, obj.Url);
  } else {
    console.log('Browser does not support HTML5.');
  }
};

var pushState = () => {
  var permalink = $('.grid-footer input.permalink').val();
  appendUrl(permalink.substring(permalink.indexOf('?') + 1, permalink.length), permalink);
};

var removeAllTag = () => {
  $('.heightTagRefn').empty();
  $('.labelTagRefn').empty();
  $('.storeTagRefn').empty();
  $('.cateTagRefn').empty();
  $(".clearForm_1").trigger('click');
  $(".clearForm_2").trigger('click');
  $(".clearForm_3").trigger('click');
  $(".clearForm_4").trigger('click');
  var form = $('#maincontent form.drawer-pc__form');
  var action = form.prop('action');
  var params = getCurrentParamsUrl(action);
  form.prop('action',
    URLhelper(
      'only',
      form.data('base-url'),
      null ,
      params.hasOwnProperty('coordinate_genre') ? { coordinate_genre : params.coordinate_genre } : 
      params.hasOwnProperty('gender') ? { gender : params.gender } : '')
  );
  getCount(form.data('count-url'), form.prop('action'));
}

var removeOneTag = () => {
  $(document).on('click', '.tag_icon .tag_icon_close:not(".outside")', function () {
    var $this = $(this).parent();
    var form = $('#maincontent form.drawer-pc__form');
    var params = getCurrentParamsUrl(form.prop('action'));
    params[$this.data('elm-name')] = params[$this.data('elm-name')].replace($this.data('val'), '').split(',').filter(Boolean).join(',');
    if (params[$this.data('elm-name')] === '') delete params[$this.data('elm-name')];
    $(`input[name=${$this.data('elm-name')}][value='${$this.data('val')}']`).prop('checked', false);
    if ($this.siblings().length === 0) $this.parent().siblings('dt').children('p').text('指定なし');
    $this.remove();
    form.prop('action',
      URLhelper(
        'only',
        form.data('base-url'),
        null,
        params
      )
    );
    getCount(form.data('count-url'),form.prop('action'));
  })
}

var chooseCate = (elm, isUnselect = false) => {
  if (elm && !$(elm).hasClass('is-active')) {
    $(elm).siblings().removeClass('is-active');
    $(elm).addClass('is-active');
  } else {
    $(elm).removeClass('is-active');
  }
  $('.drawer__filter').empty();
  var form = $('#maincontent form.drawer-pc__form');
  if (!FIRST_COUNT) {
    form.prop('action',URLhelper('only',form.data('base-url'),null,getCurrentParamsUrl(location.href)));
  } else if (!isUnselect) {
    form.prop('action',URLhelper('only',form.data('base-url'),null ,
        $(elm).prop('name') === 'coordinate_genre' ? { coordinate_genre : $(elm).data('val') } :
        $(elm).prop('name') === 'gender' ? { gender : $(elm).data('val') } : ''
    ));
  } else if (isUnselect) {
    form.prop('action', URLhelper('only',form.data('base-url'),null,null));
  }

  return $.ajax({
    method: 'get',
    data:
      isUnselect
        ? {}
        :
        {
          [$(elm).prop('name')]: $(elm).data('val')
        },
    // async: false,
    url: $('dd.drawer-pc__input').data('url'),
    success: function (respone) {
      $('.drawer__filter').empty();
      $('.drawer__filter').append(respone.drawer);
      $('.drawer__input').empty();
      $('.drawer__input').append(respone.drawerInput);
      var action = $('#maincontent form.drawer-pc__form').prop('action');
      var currentSort = (new URLSearchParams(window.location.search)).get('sort');
      form.prop('action', URLhelper('all', form.data('base-url'), action, currentSort && { sort: currentSort }));
      getCount(form.data('count-url'), form.prop('action'));
    },
    error: function () {
    },
  });
}

var dynamicUrl = () => {
  chooseCate(`input[name="coordinate_genre"][data-val="${getCurrentParamsUrl(location.href).coordinate_genre}"], input[name="gender"][data-val="${getCurrentParamsUrl(location.href).gender}"]`).done(function () {
    $('#maincontent ul.conditions__items').empty();
    var data = getCurrentParamsUrl(location.href);
    if (data.hasOwnProperty('user_id') && data.hasOwnProperty('user_name') && data['user_id'] && data['user_name']) {
      $('.product-list__header ul.conditions__items').append(tag_search_result(data['user_id'], data['user_name'], 'user_id', true))
    }
    if (data.hasOwnProperty('base_product_code') && data.hasOwnProperty('base_product_name') && data['base_product_code'] && data['base_product_name']) {
      $('.product-list__header ul.conditions__items').append(tag_search_result(data['base_product_code'], data['base_product_name'], 'base_product_code', true))
    }
    Object.keys(data).forEach((key) => {
      switch (key) {
        case 'coordinate_genre': case 'gender':
          var elm = $(`#maincontent input[name="${key}"][data-val="${data[key]}"]`);
          if (data[key] !== '') $('.product-list__header ul.conditions__items').append(tag_search_result($(elm).data('val'), $(elm).val(), $(elm).prop('name'), true))
          break;
        case 'from_height':
          var checkboxElm = $($(`#maincontent input[name="${key}"][value="${data[key]}"]`)[0])
          checkboxElm.trigger('click');
          if (checkboxElm.val()) {
            $('.heightTagRefn').append(tag_search_result(checkboxElm.val(), checkboxElm.parent().text(), key));
            $('.product-list__header .conditions__items').append(tag_search_result(checkboxElm.val(), checkboxElm.parent().text(), key, true))
          }
          break;
        case 'coordinate_label_id': case 'shop_code': case 'label_code': case 'category':
          var tagRefn = '';
          switch (key) {
            case 'coordinate_label_id': case 'label_code':
              tagRefn = '.labelTagRefn';
              break;
            case 'shop_code':
              tagRefn = '.storeTagRefn';
              break;
            case 'category':
              tagRefn = '.cateTagRefn';
              break;
            default:
              break;
          }
          data[key].split(',').forEach((elm, i) => {
            var checkboxElm = $($(`#maincontent input[name="${key}"][value="${elm}"]`)[0])
            checkboxElm.trigger('click');
            if (checkboxElm.val()) {
              $(tagRefn).append(tag_search_result(checkboxElm.val(), checkboxElm.parent().text(), key));
              $('.product-list__header .conditions__items').append(tag_search_result(checkboxElm.val(), checkboxElm.parent().text(), key, true))
            }
          });
          break;
        case 'sort':
          var sortId = data[key];
          if (sortId) {
            $('select[name="sort"] option').each(function (index, option) {
              if ($(option).val() === sortId) {
                $('select[name="sort"]').val(sortId);
              }
            });
          }
          break;
        default:
          break;
      }
    });
    if ($('.product-list__header .conditions__items').children().length > 0 ) {
      if (window.matchMedia("(max-width: 768px)").matches) {
        $('.product-list__conditions.conditions').css('display', 'block');
      } else {
        $('.product-list__conditions.conditions').css('display', 'flex');
      }
      $(window).resize(function () {
        if (window.matchMedia("(max-width: 768px)").matches) {
          $('.product-list__conditions.conditions').css('display', 'block');
        } else {
          $('.product-list__conditions.conditions').css('display', 'flex');
        }
      });
    } else {
      $('.product-list__conditions.conditions').css('display', 'none');
    }
    FIRST_COUNT = true;
    var form = $('#maincontent form.drawer-pc__form');
    getCount(form.data('count-url'),form.prop('action'));
  });
}

$(function () {
  // Define add Tag
  addTag('.sidenav_button_1_push, .sidenav_1 .drawer-pc__icon_2', '.heightTagRefn', 'from_height');
  addTag('.section-styling-list .sidenav_button_2_push, .section-styling-list .sidenav_2 .drawer-pc__icon_2', '.labelTagRefn', 'coordinate_label_id');
  addTag('.sidenav_button_3_push, .sidenav_3 .drawer-pc__icon_2', '.storeTagRefn', 'shop_code');
  addTag('.section-ranking-list .sidenav_button_2_push, .section-ranking-list .sidenav_2 .drawer-pc__icon_2', '.labelTagRefn', 'label_code');
  addTag('.sidenav_button_4_push, .sidenav_2 .drawer-pc__icon_2', '.cateTagRefn', 'category');
  // Button reset all tag inside
  $(document).on('click','.drawer-pc__btn input[type="reset"]', function (e) {
    removeAllTag();
    e.preventDefault();
    chooseCate('input.is-active[name="coordinate_genre"], input.is-active[name="gender"]', true);
  });
  // Define remove one tag inside
  removeOneTag();
  // Gender button select
  $(document).on('click','input[name="coordinate_genre"]:not(".is-active"), input[name="gender"]:not(".is-active")', function (e) {
    e.preventDefault();
    chooseCate(this);
  });
  // Filter submit event
  $(document).on('submit', 'form.drawer-pc__form', function (e) {
    e.preventDefault();
    location.href =URLhelper(
      'exclude',
      $(this).data('base-url'),
      $(this).prop('action'),
      'start,page'
    )
  })
  // Dynamic URL
  dynamicUrl();

  $(document).on('click', '.product-list__header .conditions__items .tag_icon_close', function (e) {
    e.preventDefault();
    var params = getCurrentParamsUrl(location.href);
    var $this = $(this).parent();
    if ($this.data('elm-name') === 'coordinate_genre' || $this.data('elm-name') === 'gender') {
      location.href = URLhelper(
        'exclude',
        $('form.drawer-pc__form').data('base-url'),
        $('form.drawer-pc__form').prop('action'),
        'start,page,category,coordinate_genre,gender'
      );
    } else {
      params[$this.data('elm-name')] = params[$this.data('elm-name')].replace($this.data('val'), '').split(',').filter(Boolean).join(',');
      delete params['start'];
      delete params['page'];
      location.href = $('form.drawer-pc__form').data('base-url') + `?${ $.param(params) }`;
    }
  });

  $('.lac-volume.lac-button, .lac-fullscreen.lac-button').addClass('d-none');
})

//シェアボタン
var userAgent = navigator.userAgent;
if (/Android/i.test(userAgent) && /MGRe/i.test(userAgent)) {
  $('.urlShare_button').css('display', 'none');
}
const shareButton = document.getElementById('webShareApi_buttom');
if (shareButton) {
  shareButton.addEventListener('click', async () => {
    try {
      await navigator.share(
        {
          url: location.href
        });
    } catch (error) {
      console.error
    }
  });
}

new Swiper('.js-staff-styling-swiper', {
  slidesPerView: 2.5,
  spaceBetween: 10,
  enabled: false,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    769: {
      slidesPerView: 4,
      spaceBetween: 20
    }
  },
});

// when click video handle add icon play
$(window).on('load', function() {
  $(document).on('click', '.swiper-slide-active', function () {
      var $activeSlide = $(this);
      if (checkInterval) {
          clearInterval(checkInterval);
      }
      if ($(window).width() < 768) {
        $activeSlide.find('.liveact-controls').removeClass('faded-out');
      }
      if ($activeSlide.find('video').length) {
          if ($activeSlide.find('.lac-buttonon').length) {
              $activeSlide.find('.lac-screen-play').addClass('liveact-player__element--invisible');
              checkVideoPause();
          } else {
              $activeSlide.find('.lac-screen-play').removeClass('liveact-player__element--invisible');
          }
      }
  });
  if ($(window).width() < 768) {
    $(window).scroll(function(){
      index = 0; // reset index when scrolling
      $('.gallery .swiper-slide-active').find('.liveact-controls').removeClass('faded-out');
    });
  }
});



